import api from "@/shared/api/base-api";
import { Banner } from "../model/types";

export const bannerApi = {
  getAll: async (): Promise<Banner[]> => {
    const { data } = await api.get("/v2/banner");
    return data.banners;
  },
};